import { TextField } from "@mui/material";
import { validateVariableDataValues } from "./variableData";
import { useState } from "react";

const VariableName: React.FC<any> = ({ data, index, onChange, setValidationError }) => {
    const [validationErrorMsg, setValidationErrorMsg] = useState<string>("");

    const handleChange = (value: any) => {
        const error = validateVariableDataValues(value, "value", "Value cannot be empty");
        setValidationErrorMsg(error);
        setValidationError?.(!!error)
        onChange(value, "value", index)
    }

    return (
        <TextField
            size="medium"
            sx={{
                m: 1,
                flex: 1.1,
                minWidth: "12em",
            }}
            placeholder="Value"
            value={data?.[index]?.value}
            onChange={({ target }) => handleChange(target.value)}
            error={validationErrorMsg != ""}
            helperText={validationErrorMsg || ""}
        />
    );
};

export default VariableName;
